<div
  class="tile"
  [routerLink]="isNavigateToProductEnabled ? (getProductUrl(product) | localize) : null"
  (click)="onClick.emit(product)"
>
  <div class="image__wrapper">
    <app-product-labels
      class="product__labels"
      *ngIf="product && isLabelsEnabled"
      [isNew]="product.isNew"
      [isTopProducts]="product.isTopProducts"
      [isPromotion]="product.isPromotion"
      [withoutStock]="product.hasStock == null ? false : !product.hasStock"
    ></app-product-labels>

    <img
      class="product__image"
      [src]="product?.image + PresentationConstants.imagePrefix.desktop.productOthers"
      [alt]="product?.name + ' image'"
    />
  </div>
  <div class="tile-right-part">
    <div class="row">
      <div>
        <p class="product__code" (click)="$event.stopPropagation()">
          {{ "product_tile.reference_abbreviation" | translate }}
          {{ product?.code }}
        </p>
        <h2 class="product__name">{{ product?.name }}</h2>
      </div>
      <span class="actions">
          <ep-fav-button
                  class="add-to-list-button"
                  *ngIf="hasAddToListButton && !hasDeleteButton && (isLoggedIn$ | async) && !(isGuest$ | async)"
                  [product]="product"
                  [isFavorite]="product?.isFavorite"
                  [returnUrl]="returnUrl"
          ></ep-fav-button>
          <svg-icon
                  class="close-button"
                  *ngIf="hasDeleteButton"
                  (click)="onClickDeleteButton.emit(product); $event.stopPropagation()"
                  src="./assets/icons/close.svg"
          ></svg-icon>
          <ng-content select="[actions]"></ng-content>
      </span>
    </div>
    <div class="row wrap-row">
      <div class="bottom-part-info">
        <p class="product__units">
          {{
            "product_tile.box_of_n_units"
              | translate: { quantity: product?.units ?? 0 }
          }}
        </p>
        <div class="row row--prices" *ngIf="isDisplayPricesEnabled && (canDisplayPrices$ | async)">
          <p class="product__price">
            {{ product?.price | localizedCurrency }}
          </p>
          <p class="product__unit-price" *ngIf="product?.unitPrice">
            {{ product?.unitPrice | localizedCurrency
            }}{{ "product_tile.unit" | translate | lowercase }}
          </p>
        </div>
      </div>
      <ep-add-to-cart-button
        *ngIf="hasAddToCartButton"
        class="add-to-cart-button"
        [product]="product"
      ></ep-add-to-cart-button>
    </div>
  </div>
</div>

<div class="pdf-button" *ngIf="hasAddToPdfButton">
  <app-add-remove-pdf-button [product]="product"></app-add-remove-pdf-button>
</div>
